export default __webpack_public_path__ + "static/media/twi.d803726d.png";